// import logo from './assets/img/icons/logo1.svg'
import logo from './assets/img/icons/COM-ROSA.svg'

const Logo = () => {
  return (
    <div className={'d-flex align-items-center '}>
      {/* <img src={logo} /> */}
      <img src={logo} width={80} style={{ height: 'auto' }} />
    </div>
  )
}

export default Logo
